import { render, staticRenderFns } from "./LeaveSummary.vue?vue&type=template&id=568b8fcb&scoped=true"
import script from "./LeaveSummary.vue?vue&type=script&lang=js"
export * from "./LeaveSummary.vue?vue&type=script&lang=js"
import style0 from "./LeaveSummary.vue?vue&type=style&index=0&id=568b8fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b8fcb",
  null
  
)

export default component.exports